export function castEnumForDisplay(
  rawEnum: string | null | undefined,
): string | null {
  if (!rawEnum) {
    return null;
  }

  const withSpaces = rawEnum.replace(/_/g, " ").toLowerCase();
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}
